import types from '../actions/types';
import produce from 'immer';

const initialState = window.tProjectGlobals.initialStates.system || {
  fixedAmount: false,
  showPrice: true,
  coupon: null,
  checkoutLabel: 'お支払いへ進む',
  loading: false,
  isTemplate: false
};

export default (state = initialState, action = {}) => {
  switch (action.type) {
    case types.TOGGLE_LOADING:
      return produce(state, draftState => {
        draftState.loading = action.payload.visible;
      });
    case types.ADD_NEW_IMAGE_OBJECT:
      return produce(state, draftState => {
        draftState.loading = false;
      });
    default:
      return state;
  }
}


// WEBPACK FOOTER //
// ./src/reducers/systemReducer.js